<div class="fixed inset-0 z-50 flex items-center justify-center bg-main-background bg-opacity-75 backdrop-blur-sm" (click)="closed.emit()">
  <div class="relative w-full max-w-xl rounded-xl bg-white shadow-xl flex flex-col max-h-[80vh]" (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="flex items-start justify-between px-6 py-4 border-b border-gray-100">
      <div>
        <p class="oswald-font text-lg text-nside-gray-400">User Statuses</p>
        <div class="mt-1 flex items-center gap-2 flex-wrap">
          <span class="rounded-full px-2 py-0.5 text-xs font-medium" [ngClass]="alertTypeClass(alert.alertTypeId)">
            {{ alertTypeName(alert.alertTypeId) }}
          </span>
          <span class="text-xs text-gray-400">{{ (alert.dateSubmitted ? alert.dateSubmitted + 'Z' : '') | date:'MM/dd/yyyy - HH:mm' }}</span>
          <span class="text-xs text-gray-400">· {{ alert.userNameSubmitted }}</span>
        </div>
      </div>
      <button type="button" (click)="closed.emit()" class="text-gray-400 hover:text-gray-600">
        <lucide-icon [img]="icons.X" [size]="18"></lucide-icon>
      </button>
    </div>

    <!-- Body -->
    <div class="flex-1 overflow-y-auto px-6 py-4">
      <spinner *ngIf="loading"></spinner>

      <ng-container *ngIf="!loading">
        <ng-container *ngIf="statuses.length > 0; else noStatuses">
          <table class="w-full text-left text-sm">
            <thead class="oswald-font text-xs uppercase text-gray-500 bg-main-background">
              <tr>
                <th class="px-3 py-2">User</th>
                <th class="px-3 py-2">Email</th>
                <th class="px-3 py-2">Status</th>
                <th class="px-3 py-2 whitespace-nowrap">Time</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let s of statuses" class="border-b hover:bg-gray-50">
                <td class="px-3 py-2.5 text-xs font-medium text-gray-900 whitespace-nowrap">{{ s.userName }}</td>
                <td class="px-3 py-2.5 text-xs text-gray-500">{{ s.userEmail }}</td>
                <td class="px-3 py-2.5">
                  <span class="rounded-full px-2 py-0.5 text-xs font-medium" [ngClass]="responseClass(s.userStatus)">
                    {{ s.userStatusName }}
                  </span>
                </td>
                <td class="px-3 py-2.5 text-xs text-gray-500 whitespace-nowrap">{{ (s.dateTimeSubmitted ? s.dateTimeSubmitted + 'Z' : '') | date:'MM/dd/yyyy - HH:mm' }}</td>
              </tr>
            </tbody>
          </table>
        </ng-container>
        <ng-template #noStatuses>
          <p class="py-10 text-center text-sm italic text-gray-400">No status responses for this alert.</p>
        </ng-template>
      </ng-container>
    </div>

    <!-- Footer -->
    <div class="px-6 py-3 border-t border-gray-100 flex justify-between items-center">
      <p class="text-xs text-gray-400">{{ statuses.length }} response{{ statuses.length !== 1 ? 's' : '' }}</p>
      <button type="button" (click)="closed.emit()"
        class="rounded-md border border-gray-300 px-4 py-1.5 text-sm text-gray-600 oswald-font hover:bg-gray-50">
        Close
      </button>
    </div>

  </div>
</div>
